import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// API URLs (replace with actual API endpoint)
const API_URL = 'https://api-inventory.neuromotion.tech/api/v1/auth';


export const adminLogin = createAsyncThunk(
  'auth/adminLogin',
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/admin/login`, credentials);
      localStorage.setItem('adminToken', response.data.token); // Store token in localStorage
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const logoutAdmin = () => {
  localStorage.removeItem('adminToken');
  return { type: 'auth/logoutAdmin' };
};

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    admin: null,
    loading: false,
    error: null,
    success: false
  },
  reducers: {
       clearError: (state) => {
        state.error = null;
      },
      clearSuccess: (state) => {
        state.success = false;
      }
  },
  extraReducers: (builder) => {
    builder.addCase(adminLogin.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(adminLogin.fulfilled, (state, action) => {
      state.loading = false;
      state.admin = action.payload;
      state.success = true;
    });
    builder.addCase(adminLogin.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.error || 'Login failed';
    });
    builder.addCase('auth/logoutAdmin', (state) => {
      state.admin = null;
      state.success = false;
    });
  }
});
export const { clearError, clearSuccess } = authSlice.actions;

export default authSlice.reducer;
